import { External } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Link from "ds/components/Link";
import LinkAdd from "ds/components/Link/LinkAdd";
import { pluralize } from "shared/Pluralize";
import { AccessResult } from "utils/access";

import OutputReferencesTextWrapper from "./TextWrapper";
import OutputReferencesTooltipWrapper from "./TooltipWrapper";

const DISALLOWED_COPY = "stacks do not support output references";

type OutputReferencesProps = {
  referenceCount?: number;
  onEdit?: () => void;
  disallowed?: boolean;
  vendorName?: string;
  canManage: AccessResult;
};

export const OutputReferences = ({
  onEdit,
  referenceCount,
  disallowed,
  vendorName,
  canManage,
}: OutputReferencesProps) => {
  const isReadOnly = !onEdit;
  const hasReferences = !!referenceCount;

  if (disallowed) {
    return (
      <OutputReferencesTextWrapper>
        <OutputReferencesTextWrapper>{vendorName}</OutputReferencesTextWrapper> {DISALLOWED_COPY}
      </OutputReferencesTextWrapper>
    );
  }

  if (isReadOnly) {
    return hasReferences ? (
      <Box gap="medium" align="center">
        <OutputReferencesTextWrapper>
          {referenceCount} Output {pluralize("reference", referenceCount)}
        </OutputReferencesTextWrapper>

        <OutputReferencesTooltipWrapper>
          This stack will run only if at least one of its output references changes.
        </OutputReferencesTooltipWrapper>
      </Box>
    ) : (
      <OutputReferencesTextWrapper>No output references</OutputReferencesTextWrapper>
    );
  }

  return hasReferences ? (
    <Box gap="medium" align="center">
      <Icon src={External} />

      <OutputReferencesTextWrapper>
        {referenceCount} Output {pluralize("reference", referenceCount)}
      </OutputReferencesTextWrapper>

      <OutputReferencesTooltipWrapper>
        This stack will run only if at least one of the output references changes.
      </OutputReferencesTooltipWrapper>

      <Link tooltip={canManage.message} disabled={!canManage.result} size="small" onPress={onEdit}>
        Edit
      </Link>
    </Box>
  ) : (
    <LinkAdd
      tooltip={canManage.message}
      disabled={!canManage.result}
      text="Add output reference"
      onClick={onEdit}
    />
  );
};
